
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_b)"}},[_c('circle',{attrs:{"cx":"22","cy":"22","r":"16","fill":"gray","fill-opacity":".25"}})]),_c('path',{attrs:{"d":"M25.657 25.657l-7.314-7.314M18.343 25.657l7.314-7.314","stroke":"#fff","stroke-width":"2","stroke-linecap":"round"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_b","x":"-34","y":"-34","width":"112","height":"112","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feGaussianBlur',{attrs:{"in":"BackgroundImage","stdDeviation":"20"}}),_c('feComposite',{attrs:{"in2":"SourceAlpha","operator":"in","result":"effect1_backgroundBlur"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_backgroundBlur","result":"shape"}})])])])
          )
        }
      }
    